'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    /********
    	description：金额转中文大写
    	paramter：
    		n:【必需】需转换大写的数值
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    uppercase: function uppercase(n) {
        var fraction = ['角', '分'];
        var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
        var unit = [['元', '万', '亿', '万'], ['', '拾', '佰', '仟']];
        var head = n < 0 ? '欠' : '';
        n = Math.abs(n);
        var s = '';
        for (var ii = 0; ii < fraction.length; ii++) {
            var index = this.findNnum(n, ii + 1);
            s += (digit[index] + fraction[ii]).replace(/零./, '');
        }
        s = s || '整';
        n = Math.floor(n);
        for (var i = 0; i < unit[0].length && n > 0; i++) {
            var p = '';
            for (var j = 0; j < unit[1].length && n > 0; j++) {
                p = digit[n % 10] + unit[1][j] + p;
                n = Math.floor(n / 10);
            }
            s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
        }
        return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
    },

    /********
    	description：格式化金额，金额添加千分位
    	paramter：
    		s:【必需】金额，必须为字符串，如果是数字太大的话会有精度问题
               n:【可选】金额保留小数位数（保留位数会进行四舍五入）
               nonEmpty:【可选】非数字显示0的格式化 或 ""
               rounding:【可选】是否开启四舍五入
               thousand:【可选】是否需要开启千分位
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    format: function format(s, n) {
        var nonEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var rounding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var thousand = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

        // 如果传进来的就是千分位，补充校验并直接返回千分位
        var reg = /((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))/;
        // 传过来的字符串不满足金额校验 直接返回0的格式化
        if (s && !reg.test(s)) {
            return nonEmpty ? 0.0.toFixed(n) + "" : '';
        }
        // 如果是千分位金额，直接返回
        if (typeof s == 'string' && s.indexOf(',') > -1) {
            return s;
        }
        // 传过来的位数超过20位会转成科学计数法
        s = s ? s.toString() : "0";
        if (isNaN(s) && typeof s != "number") return nonEmpty ? 0.0.toFixed(n) + "" : '';
        n = n >= 0 && n <= 20 ? n : 2;
        if (!rounding) {
            var _index = s.indexOf('.');
            if (_index !== -1) {
                s = s.substring(0, n + _index + 1);
            } else {
                s = s.substring(0);
            }
        }
        if (!thousand) {
            var _reg = /^\d+\.\d+$/;
            if (_reg.test(s)) {
                var xsd = s.toString().split(".");
                if (xsd[1].length < n) {
                    var afterNum = "";
                    for (var i = 0; i < n - xsd[1].length; ++i) {
                        afterNum += '0';
                    }
                    return s.toString() + afterNum.substring(0, n);
                }
                if (xsd[1].length > n) {
                    return xsd[0] + '.' + xsd[1].substring(0, n);
                }
                return s;
            } else {
                var z = "";
                for (var _i = 0; _i < n; ++_i) {
                    z += '0';
                }
                var decimal = n > 0 ? "." + z : "";
                return s + decimal;
            }
        }
        var num = void 0;
        var index = s.indexOf('.');
        if (index == -1) {
            var _z = "";
            for (var _i2 = 0; _i2 < n; ++_i2) {
                _z += '0';
            }
            var _decimal = n > 0 ? "." + _z : "";
            num = s.replace(/(\B)(?=(\d{3})+(\.\d*)?$)/g, '$1,') + _decimal;
        } else {
            var data = s.split(".");
            var beforeNum = data[0];
            var _afterNum = data[1];
            if (_afterNum.length < n) {
                for (var _i3 = 0; _i3 < n; ++_i3) {
                    _afterNum += '0';
                }
            }
            var _decimal2 = n > 0 ? '.' + _afterNum.substring(0, n) : "";
            num = beforeNum.replace(/(\B)(?=(\d{3})+(\.\d*)?$)/g, '$1,') + _decimal2;
        }
        return num;
    },

    /********
    	description：格式化金额，金额去除千分位
    	paramter：
    		str:【必需】需格式化金额
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    toNumber: function toNumber(str) {
        return str ? parseFloat(str.toString().replace(/,/g, "")) : "";
    },

    /********
    	description：数值精度计算
    	paramter：
    		num:【必需】需进行精度处理的数值
    		s:【可选】精度处理需保留的小数位
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(caobo)
    ********/
    fixedNumber: function fixedNumber(num) {
        var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

        var times = Math.pow(10, s);
        var negativeReg = /-([1-9]\d*.\d*|0.\d*[1-9]\d*)/;
        var negativeFlag = negativeReg.test(num);
        if (negativeFlag) {
            num = Math.abs(num);
        }
        var des = num * times + 0.5;
        des = parseInt(des, 10) / times;
        var reg = /^\d+\.\d+$/;
        if (reg.test(num)) {
            if (reg.test(des)) {
                var xsd = des.toString().split(".");
                if (xsd[1].length < s) {
                    var afterNum = "";
                    for (var i = 0; i < s - xsd[1].length; ++i) {
                        afterNum += '0';
                    }
                    if (negativeFlag) {
                        return '-' + des.toString() + afterNum.substring(0, s);
                    }
                    return des.toString() + afterNum.substring(0, s);
                }
                if (xsd[1].length > s) {
                    if (negativeFlag) {
                        return '-' + xsd[0] + '.' + xsd[1].substring(0, s);
                    }
                    return xsd[0] + '.' + xsd[1].substring(0, s);
                }
                if (negativeFlag) {
                    return '-' + des;
                }
                return des;
            } else {
                var _afterNum2 = "";
                for (var _i4 = 0; _i4 < s; ++_i4) {
                    _afterNum2 += '0';
                }
                if (s != 0) {
                    if (negativeFlag) {
                        return '-' + des.toString() + '.' + _afterNum2.substring(0, s);
                    }
                    return des.toString() + '.' + _afterNum2.substring(0, s);
                } else {
                    return des;
                }
            }
        } else {
            var _afterNum3 = "";
            for (var _i5 = 0; _i5 < s; ++_i5) {
                _afterNum3 += '0';
            }
            if (s != 0) {
                if (negativeFlag) {
                    return '-' + num.toString() + '.' + _afterNum3.substring(0, s);
                }
                return num.toString() + '.' + _afterNum3.substring(0, s);
            } else {
                if (negativeFlag) {
                    return '-' + num;
                }
                return num;
            }
        }
    },

    // 获取数字小数点后第n位
    findNnum: function findNnum(num, n) {
        var reg = "\\..{" + (n - 1) + "}(\\d)";
        if (new RegExp(reg).test(num + "")) {
            return RegExp.$1;
        } else {
            return 0;
        }
    },

    /********
    description：格式化金额 涉及大的金额可以用这个 必须传字符串
    paramter：
    data:要格式化的金额
    version:1.0.0
    data:2021/05/27
    changeContent:基础版(chenkailei)
    ********/
    formatMoney: function formatMoney(data) {
        if (data === null || data === undefined || data === '') return '';
        var isMoney = /^\d*(\.\d{1,2})?$/;
        if (!isMoney.test(data)) return '';
        data += '';
        var num = data.replace(/(\B)(?=(\d{3})+(\.\d*)?$)/g, '$1,');
        var lastNum = num.match(/\.\d*$/),
            lastStr = '';
        if (!lastNum) return num + '.00';
        if (lastNum[0].length == 2) return num + '0';
        return num;
    }
};